import React from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { useLanguage } from '../../../../contexts/LanguageContext';
import DashboardPanel, { PanelLink } from './DashboardPanel';
import { formatFee, formatTime, getDateBlock } from '../utils/dashboardUtils';
import { useLmsPermission } from '../../hooks/useLmsPermission';
import { LMS } from '../../../../constants/permissionCodes';

const UpcomingTrainings = ({ items, totalCount, isLoading, lazyParams, onPage }) => {
    const { th, getCurrentLocale } = useLanguage();
    const { can } = useLmsPermission();
    const locale = getCurrentLocale();

    const dateBody = (row) => {
        const { days, monthYear } = getDateBlock(row.startDate, row.endDate, locale);
        const time = [formatTime(row.startTime), formatTime(row.endTime)].filter(Boolean).join(' – ');
        return (
            <div className="flex flex-column">
                <span className="font-bold" style={{ color: '#101828', fontSize: '1.05rem' }}>
                    {days}
                </span>
                <span className="text-xs font-semibold" style={{ color: '#475467' }}>
                    {monthYear}
                </span>
                {time && (
                    <span className="text-xs" style={{ color: '#98A2B3' }}>
                        {time}
                    </span>
                )}
            </div>
        );
    };

    const trainingBody = (row) => (
        <div className="flex flex-column">
            <span className="font-medium" style={{ color: '#101828' }}>
                {row.trainingName}
            </span>
            {row.trainingCode && (
                <span className="text-xs" style={{ color: '#667085' }}>
                    {th('lmsDashboard.upcoming.code', { code: row.trainingCode })}
                </span>
            )}
        </div>
    );

    const locationBody = (row) =>
        row.planningLocationText ? (
            <span className="flex align-items-center gap-2" style={{ color: '#344054' }}>
                <i className="pi pi-map-marker" style={{ fontSize: '0.85rem' }} />
                {row.planningLocationText}
            </span>
        ) : (
            '-'
        );

    return (
        <DashboardPanel title={th('lmsDashboard.upcoming.title')} action={can(LMS.TRAINING_VIEW) ? <PanelLink to="/learning-management-system/training-planning" label={th('lmsDashboard.viewAll')} /> : null}>
            <div className="lms-dashboard-upcoming">
                <DataTable
                    value={items}
                    dataKey="planningId"
                    lazy
                    paginator
                    first={lazyParams.first}
                    rows={lazyParams.rows}
                    totalRecords={totalCount}
                    onPage={onPage}
                    rowsPerPageOptions={[5, 10, 20]}
                    loading={isLoading}
                    emptyMessage={th('lmsDashboard.upcoming.empty')}
                    responsiveLayout="scroll"
                >
                    <Column header={th('lmsDashboard.upcoming.date')} body={dateBody} style={{ width: '10rem' }} />
                    <Column header={th('lmsDashboard.upcoming.training')} body={trainingBody} />
                    <Column header={th('lmsDashboard.upcoming.trainingType')} field="trainingTypeText" />
                    <Column header={th('lmsDashboard.upcoming.location')} body={locationBody} />
                    <Column header={th('lmsDashboard.upcoming.language')} field="trainingLanguage" />
                    <Column header={th('lmsDashboard.upcoming.capacity')} field="trainingCapacity" align="center" style={{ width: '7rem' }} />
                    <Column header={th('lmsDashboard.upcoming.price')} body={(row) => formatFee(row.fee, row.currency, locale)} style={{ width: '8rem' }} />
                </DataTable>
            </div>
        </DashboardPanel>
    );
};

export default UpcomingTrainings;
